/**
 * Identifier shape guards for admin-ui forms that accept pasted IDs.
 *
 * The commerce/ticketing domain mints UUIDs (`@default(uuid())` in Prisma),
 * while other parts of this platform mint 24-char Mongo ObjectIds or cuids.
 * Forms here take raw pasted text, so a mismatch used to reach the service and
 * come back as the opaque `"Request validation failed"`. Check the shape
 * client-side to name the actual problem.
 */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const OBJECT_ID_RE = /^[0-9a-f]{24}$/i;
const CUID_RE = /^c[a-z0-9]{20,}$/i;

export function isUuid(value: string): boolean {
  return UUID_RE.test(value.trim());
}

/** Names the likely source of a pasted ID that is not a UUID, if recognisable. */
export function describeIdShape(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed || isUuid(trimmed)) return null;
  if (OBJECT_ID_RE.test(trimmed)) return 'this looks like a 24-character MongoDB ObjectId';
  if (CUID_RE.test(trimmed)) return 'this looks like a cuid';
  return 'this is not a UUID';
}